import React from "react";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import _ from "lodash";
// import FormLabel from "@material-ui/core/FormLabel";

// import _ from "lodash";
// import { makeStyles } from "@material-ui/core/styles";
// import { getSiteParams } from "../../configuration/wizardConfiguration";
// import { m, detectBrowserLanguage } from "../../utils/i18n";
import { AutocompleteList } from "./../AutocompleteList";
import { evalExpression } from "../../utils/parseUtils";
// const siteParams = getSiteParams();

// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 280,
//   },
//   selectEmpty: {
//     marginTop: theme.spacing(5),
//   },
// }));

export const MultiInputStep = (props) => {
  const { formData, setFormValues, stepData, errors, setErrors } = props;
  // const classes = useStyles();
  // // const { name, email } = formData;
  // // todo prendere con codice giusto
  // const name = "nametest";

  const { fields } = stepData.params;

  // const [errors, setErrors] = React.useState({});

  // // http://emailregex.com/
  // function validateEmail(mail) {
  //   if (
  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
  //       mail
  //     )
  //   ) {
  //     return true;
  //   }
  //   return false;
  // }

  const handleChange = (event) => {
    // var err = {};
    // err.shortsidelength = "ciccio";
    // setErrors({ ...err });

    let updatedFormData = { ...formData };
    updatedFormData[event.target.name] = event.target.value;
    setFormValues({ ...updatedFormData });
  };

  // // https://bit.ly/3DD7Irt
  // function validatePostalCode(mail) {
  //   const lang = detectBrowserLanguage();

  //   const regex = lang === "it" ? /^[0-9]{5}$/ : /(.|\s)*\S(.|\s)*/;
  //   // if (/^[0-9]{5}$/.test(mail)) {

  //   if (regex.test(mail)) {
  //     return true;
  //   }
  //   return false;
  // }

  // const handleGetPdf = (event) => {
  //   const isEmailValid = validateEmail(formData.email);
  //   const isPostalCodeValid = validatePostalCode(formData.postalCode);

  //   // verifica segnalazione 15.06.2021 -> può aver senso resettare err prima
  //   // di questi controlli per ripulire eventualu errori incastrati?
  //   let err = { ...errors };

  //   if (!siteParams.fill_form_enabled) {
  //     return;
  //   }

  //   if (_.isEmpty(formData.userCategory)) {
  //     err.userCategory = m("common.error.required_userCategory");
  //     // setErrors({ name: m("common.error.required_name") });
  //     setErrors(err);
  //     event.preventDefault();
  //   }

  //   if (!isEmailValid) {
  //     err.email = m("common.error.required_or_invalid_email");
  //     // { email: m("common.error.required_or_invalid_email") }
  //     setErrors(err);
  //     event.preventDefault();
  //   }

  //   if (_.isEmpty(formData.name)) {
  //     err.name = m("common.error.required_name");
  //     // setErrors({ name: m("common.error.required_name") });
  //     setErrors(err);
  //     event.preventDefault();
  //   }

  //   if (_.isEmpty(formData.fullAddress)) {
  //     err.fullAddress = m("common.error.required_full_address");
  //     // setErrors({ name: m("common.error.required_name") });
  //     setErrors(err);
  //     event.preventDefault();
  //   }

  //   if (!isPostalCodeValid) {
  //     err.postalCode = m("common.error.required_or_invalid_postal_code");
  //     // setErrors({ name: m("common.error.required_name") });
  //     setErrors(err);
  //     event.preventDefault();
  //   }

  //   if (_.isEmpty(formData.province)) {
  //     err.province = m("common.error.required_province");
  //     // setErrors({ name: m("common.error.required_name") });
  //     setErrors(err);
  //     event.preventDefault();
  //   }
  // };

  // const handleEmailChange = (event) => {
  //   let updatedFormData = { ...formData };
  //   updatedFormData["email"] = event.target.value.trim();
  //   setFormValues({ ...updatedFormData });
  // };

  const handleFocus = (event) => {
    let err = { ...errors };
    err[event.target.name] = "";
    setErrors(err);
  };

  // const getPdfUrl = (event) => {
  //   // const filters = _.omitBy(formData, _.isEmpty);

  //   const qs = Object.keys(formData)
  //     .map((key) => `${key}=${encodeURIComponent(formData[key])}`)
  //     .join("&");

  //   const url = `${siteParams.pdf_url}?${qs}`;

  //   return url;
  // };

  // const props_and_errrors = {
  //   ...props,
  //   ...{ errors: errors },
  //   ...{ setErrors: setErrors },
  // };

  return (
    <Container maxWidth="xs">
      {/* <FormControl className={classes.formControl}> */}
      {fields.map((field) => {
        // stuff
        const showIfCondition = field.showIf;
        const show = evalExpression(showIfCondition, formData);

        if (show) {
          switch (field.type) {
            case "text":
              return (
                <TextField
                  label={field.label}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  margin="normal"
                  variant="outlined"
                  autoComplete="off"
                  required
                  error={Boolean(errors[field.name])}
                  helperText={errors[field.name]}
                  fullWidth
                />
              );

            case "list":
              var selected;
              if (
                formData[field.name] !== undefined &&
                formData[field.name] !== ""
              ) {
                selected = _.find(field.options, {
                  value: formData[field.name],
                });
              }

              const props_and_errrors = {
                ...props,
                ...{ errors: errors },
                ...{ setErrors: setErrors },
                ...{ listWidget: field },
                ...{ defaultValue: selected },
              };
              // defaultValue={{ title: "The Godfather", year: 1972 }}
              return (
                <AutocompleteList {...props_and_errrors} />
                // <Select
                //   labelId={field.label}
                //   id={field.name}
                //   value={formData[field.name]}
                //   onChange={handleChange}
                //   displayEmpty
                //   fullWidth
                //   className={classes.selectEmpty}
                //   IconComponent={(props) => (
                //     <ArrowDropDownIcon fontSize="large" {...props} />
                //   )}
                // >
                //   <MenuItem value="">
                //     <em>{m("common.select.placeholder")}</em>
                //   </MenuItem>
                //   {field.options.map((data, index) => {
                //     return (
                //       <MenuItem key={data.value} value={data.value}>
                //         {data.label}{" "}
                //       </MenuItem>
                //     );
                //   })}
                // </Select>
              );
            default:
              return <>check default</>;
          }
        }
        return <></>;
      })}
      {/* </FormControl> */}
    </Container>
  );
};
